import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  async getUserSettings({ commit }, userId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getUserSettings}/${userId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async saveUserSettings({ commit }, settings) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.saveUserSettings}`,
        settings,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
